import { ModalHeader } from '@scaleaq/scaleui';
import { useTranslation } from 'react-i18next';

import { StyledModal } from '@/styles.ts';
import { ModalControllerType } from '@/types.ts';

import { BiomassDistributionModalContent } from './biomassDistributionModal/BiomassDistributionModalContent.tsx';

type BiomassDistributionModalProps = {
  widgetId: string;
  modalController: ModalControllerType;
};

export const BiomassDistributionModal = ({
  widgetId,
  modalController,
}: BiomassDistributionModalProps) => {
  const { t } = useTranslation(['orbitOne']);
  const { open, onClose } = modalController;

  return (
    <StyledModal open={open} onClose={onClose}>
      <ModalHeader title={t('orbitOne:biomassDistribution.config.title')} onClose={onClose} />
      <BiomassDistributionModalContent widgetId={widgetId} onSave={onClose} onClose={onClose} />
    </StyledModal>
  );
};
